import { useReducedMotion } from 'motion/react'

/**
 * `prefers-reduced-motion` do usuário.
 *
 * O Motion já respeita a preferência sozinho; este hook existe para os casos
 * que ele não alcança — pular a animação nativa do gráfico do MUI X, parar o
 * gradiente do fundo, preencher o formulário de uma vez em vez de campo a
 * campo.
 */
export function usePrefersReducedMotion(): boolean {
  return useReducedMotion() ?? false
}
